// extracted by mini-css-extract-plugin
export default {"new-pill":"new-pill-fqvFkcD"};